module.exports = __webpack_public_path__ + "img/plan-a-on.5c3a4cc4.png";